import { z } from 'zod';

export const FileMembershipRightsValidationSchema = z.object({
  hasWriteRights: z.boolean(),
});

export type FileMembershipRightsValidator = z.infer<typeof FileMembershipRightsValidationSchema>;
